/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Error_Invalid_CredentialInputs */



/**
* | output |
* | --- |
* | "Invalid email or password." |
*
* @param {Login_Error_Invalid_CredentialInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_error_invalid_credential = /** @type {((inputs?: Login_Error_Invalid_CredentialInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Error_Invalid_CredentialInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Email ou mot de passe invalide.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ungültige E-Mail-Adresse oder ungültiges Passwort.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Email o password non valide.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Неверный адрес электронной почты или пароль.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Correo electrónico o contraseña no válidos.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("邮箱或密码无效。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("メールアドレスまたはパスワードが無効です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("गलत ईमेल या पासवर्ड।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("E-mail ou senha inválidos.")
	return /** @type {LocalizedString} */ ("Invalid email or password.")
});